import styled from 'styled-components';
export const VideoRatio16By9 = styled.div `
  background-color: rgba(0, 0, 0, 0.25);
  padding: 56.25% 0 0 0;
  position: relative;
  overflow: hidden;
`;
export const ResponsiveVideoWrapper = styled.div `
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
export const VideoEmbed = styled.div `
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=styled.js.map